import React from 'react';
import { View, Text, Image, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

const SelectableImage = (props) => {

	const { imageData, imageSize, style } = props;
	const { width, height } = imageSize ? imageSize : { width: 250, height: 250 };


	if (imageData != null) {
		return (
			<TouchableOpacity
				// onPress={() => props.navigation.navigate('ImageView', { uri: imageData })}
				onPress={() => {}}
				style={style}
			>
				<Image
					style={{ width: width, height: height, borderRadius: 8 }}
					source={{ uri: imageData }}
					resizeMode={'contain'}
				/>
			</TouchableOpacity>
		)
	} else {
		return null
	};
};

export default SelectableImage;
